import { render } from "./TheSiteGuidance.vue?vue&type=template&id=98c0ddc6&scoped=true&ts=true"
import script from "./TheSiteGuidance.vue?vue&type=script&lang=ts"
export * from "./TheSiteGuidance.vue?vue&type=script&lang=ts"

import "./TheSiteGuidance.vue?vue&type=style&index=0&id=98c0ddc6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98c0ddc6"]])

export default __exports__